import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  openFormModal,
  setSearch,
  setTalentoFilter,
  setPreguntaFilter,
  clearFilters,
} from "../../store/reducers/frasesConfirmacion/frasesConfirmacion.reducer";
import SearchInput from "../UI/SearchInput";
import Select2 from "../UI/Select2";
import { getTalentosSelectoresService } from "../../services/frases/frases.service";
import { getPreguntasSelectoresService } from "../../services/preguntasConfirmacion/preguntasConfirmacion.service";

const FrasesConfirmacionHeader = () => {
  const dispatch = useDispatch();
  const { search, talentoFilter, preguntaFilter } = useSelector(
    (state) => state.frasesConfirmacion
  );

  const handleSearchChange = (value) => {
    dispatch(setSearch(value));
  };

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresService(searchTerm);
    return response.map((item) => ({
      id: item.id,
      label: item.label,
    }));
  };

  const fetchPreguntas = async (searchTerm) => {
    const response = await getPreguntasSelectoresService(searchTerm);
    return response.map((item) => ({
      id: item.id,
      label: item.label,
    }));
  };

  const handleTalentoChange = (value) => {
    dispatch(setTalentoFilter(value || ""));
  };

  const handlePreguntaChange = (value) => {
    dispatch(setPreguntaFilter(value || ""));
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  const hasFilters = search || talentoFilter || preguntaFilter;

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        {/* título */}
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Frases de confirmación
          </h5>
        </div>

        {/* controles */}
        <div className="col-12 col-md">
          <div className="d-flex flex-column gap-2">
            {/* Primera fila: buscador + botón agregar */}
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
              <SearchInput
                value={search}
                onChange={handleSearchChange}
                placeholder="Buscar frases..."
                minChars={3}
                className="flex-grow-1"
              />

              <button
                onClick={() => dispatch(openFormModal({ mode: "create" }))}
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8"
                style={{ height: "44px", minWidth: "140px" }}
              >
                <Icon icon="mdi:plus" width="20" />
                <span className="d-none d-sm-inline fw-medium">Nueva frase</span>
                <span className="d-inline d-sm-none fw-medium">Nueva</span>
              </button>
            </div>

            {/* Segunda fila: filtros */}
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end align-items-sm-end">
              <div style={{ minWidth: "200px", maxWidth: "300px" }}>
                <Select2
                  value={talentoFilter}
                  onChange={handleTalentoChange}
                  fetchOptions={fetchTalentos}
                  placeholder="Filtrar por talento..."
                  isClearable
                />
              </div>

              <div style={{ minWidth: "200px", maxWidth: "300px" }}>
                <Select2
                  value={preguntaFilter}
                  onChange={handlePreguntaChange}
                  fetchOptions={fetchPreguntas}
                  placeholder="Filtrar por pregunta..."
                  isClearable
                />
              </div>

              {hasFilters && (
                <button
                  onClick={handleClearFilters}
                  className="btn btn-outline-secondary d-flex align-items-center gap-1"
                  style={{ height: "44px" }}
                  title="Limpiar filtros"
                >
                  <Icon icon="mdi:filter-remove-outline" width="18" />
                  <span className="d-none d-sm-inline">Limpiar</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrasesConfirmacionHeader;
